<template>
    <div class="vx-row">
        <div class="vx-col sm:w-full">
            <vs-input class="inputx sm:w-full" :placeholder="$t('Search')" @input="$emit('search',value)" v-model="value"/>
        </div>
        <div class="vx-col sm:w-1/2">
            <vs-select name="included" class="w-full mt-2" :placeholder="$t('Order')"  v-model="order" @change="$emit('order',order)">
                <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in orders"/>
            </vs-select>
        </div>
        <div class="vx-col sm:w-1/2">
            <vs-select name="included" class="w-full mt-2" :placeholder="$t('Filter')" v-model="filter" @change="$emit('filter',filter)">
                <vs-select-item :key="index" :value="$t(item.type)" :text="item.label" v-for="(item,index) in filters"/>
            </vs-select>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Search",
        props:{
            filterType:{type:String},
            currentFilter:{type:String}
        },
        data(){
            return{
                value:"",
                order:{},
                filter:{},

                orders:[{value:'A-Z',text:"A-Z"}],
            }
        },
        computed:{
            filters(){
                return [{type:"all",label:"All"},...this.$store.getters.labels(this.filterType)];
            }
        },
        watch:{
            currentFilter(){
                this.filter = this.currentFilter
            }
        }
    }
</script>